import { Link } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';
import { ThemeToggle } from '../../app/ThemeToggle';
import { UserMenu } from '../../app/UserMenu';
import { Brand } from '../../app/Brand';

export function WorkspaceHeader({ backTo, backLabel, title, children, actions }) {
  return (
    <header className="workspace-header">
      <Link to="/problems" className="brand workspace-header__brand" viewTransition>
        <Brand showName={false} />
      </Link>
      <Link to={backTo} className="workspace-header__back" viewTransition>
        <LuArrowLeft aria-hidden="true" />
        <span>{backLabel}</span>
      </Link>
      <span className="workspace-header__divider" aria-hidden="true" />
      {title && <span className="workspace-header__title">{title}</span>}
      {children}
      <div className="workspace-header__end">
        {actions}
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}
